import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ForexSpread from "../pages/forex-spread/page";
import ForexCommission from "../pages/forex-commission/page";
import SpreadVsCommission from "../pages/spread-vs-commission/page";
import ForexSwap from "../pages/forex-swap/page";
import ForexSlippage from "../pages/forex-slippage/page";
import ForexTradingCostsByStrategy from "../pages/forex-trading-costs-by-strategy/page";
import HiddenForexTradingCosts from "../pages/hidden-forex-trading-costs/page";
import CalculateForexTradingCosts from "../pages/calculate-forex-trading-costs/page";
import PagePlaceholder from "../components/feature/PagePlaceholder";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about/",
        element: <AboutPage />,
      },
      {
        path: "/forex-spread/",
        element: <ForexSpread />,
      },
      {
        path: "/forex-commission/",
        element: <ForexCommission />,
      },
      {
        path: "/spread-vs-commission/",
        element: <SpreadVsCommission />,
      },
      {
        path: "/forex-swap/",
        element: <ForexSwap />,
      },
      {
        path: "/forex-slippage/",
        element: <ForexSlippage />,
      },
      {
        path: "/calculate-forex-trading-costs/",
        element: <CalculateForexTradingCosts />,
      },
      {
        path: "/hidden-forex-trading-costs/",
        element: <HiddenForexTradingCosts />,
      },
      {
        path: "/forex-trading-costs-by-strategy/",
        element: <ForexTradingCostsByStrategy />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;